<script lang="ts">
    import AppLayout from "@/layouts/AppLayout.svelte";
    import CreateJobModal from "@/components/jobs/CreateJobModal.svelte";
    import type {Field} from "@/types/types";
    import type Blocks from '@/schemas/public/Blocks.ts';
    import {Plus} from "lucide-svelte";
    import JobTable from "@/components/jobs/JobTable.svelte";

    type StatusOption = {
        value: string;
        label: string;
        color: string;
    };

    type Props = {
        blocks: (Blocks & {fields: Field[]})[];
        statusOptions: StatusOption[];
    };

    let {blocks, statusOptions = []}: Props = $props();

    let breadcrumbs = $state([
        {title: 'Jobs', href: route('jobs.index')},
    ]);
    let actionbuttons = $state([
        {
            title: 'Add New Job',
            href: undefined,
            icon: Plus,
            onClick: openCreateJobModal
        }
    ]);

    let showCreateJobModal = $state(false);

    function openCreateJobModal() {
        showCreateJobModal = true;
    }
</script>


<svelte:head>
    <title>Jobs</title>
</svelte:head>

<AppLayout {breadcrumbs} {actionbuttons}>
    <JobTable
        view="index"
        {statusOptions}
    />

    <CreateJobModal
        {blocks}
        bind:show={showCreateJobModal}
    />
</AppLayout>